<template>
  <el-dialog
      width="70%"
      top="20px"
      title="拍照上传"
      @close="hideModal"
      append-to-body
      custom-class="dialog-email-two common-style"
      :visible.sync="visibleFlag"
  >
    <div class="photo-cropper-container">
      <el-card class="box-card">
        <!-- 操作按钮区域 -->
        <el-row :gutter="20" class="mb-20">
          <el-col :span="24">
            <el-button type="primary" @click="openCamera" :disabled="showCamera">
              <i class="el-icon-camera"></i>
              拍照
            </el-button>
            <el-button type="success" @click="uploadImage" :disabled="showCamera">
              <i class="el-icon-upload"></i>
              上传图片
            </el-button>
            <el-button type="warning" @click="resetAll" v-if="croppedImage || showCamera">
              <i class="el-icon-refresh"></i>
              重置
            </el-button>
          </el-col>
        </el-row>

        <!-- 主要内容区域 -->
        <el-row :gutter="20">
          <!-- 左侧：拍照/预览区域 -->
          <el-col :span="16">
            <el-card class="left-panel">
              <div slot="header" style="display: flex;align-items: center;justify-content: space-between;">
                <span>{{ showCamera ? '拍照预览' : '图片预览' }}</span>
              </div>

              <!-- 拍照区域 -->
              <div v-if="showCamera" class="camera-container">
                <video ref="video" autoplay class="camera-video"></video>
                <canvas ref="canvas" style="display: none;"></canvas>

              </div>

              <!-- 图片预览区域 -->
<!--              <div v-else-if="previewImage" class="preview-container">
                <img :src="previewImage" alt="预览图片" class="preview-image" />
              </div>-->
              <div v-else-if="showCropper" class="cropper-container">
                <vue-cropper
                    ref="cropper"
                    :img="cropperImage"
                    :outputSize="1"
                    :info="true"
                    :full="true"
                    :canMove="true"
                    :canMoveBox="true"
                    :original="false"
                    :autoCrop="true"
                    :fixedNumber="[1, 1]"
                    :centerBox="true"
                    :infoTrue="true"
                    :high="true"
                    mode="cover"
                    :maxImgSize="2000"
                    :enlarge="1"
                    :maxRealScale="3"
                    @realTime="realTime"
                />
              </div>
              <div v-else-if="croppedImage" class="result-container">
                <h3>裁剪结果：</h3>
                <div class="cropped-image-wrapper">
                  <img :src="croppedImage" alt="裁剪后的图片" class="cropped-image" />
                </div>
                <div class="result-controls">
                  <el-button type="success" @click="downloadImage" size="large">
                    <i class="el-icon-download"></i>
                    下载图片
                  </el-button>
                  <el-button type="primary" @click="handleUploadImage" size="large">
                    <i class="el-icon-document-copy"></i>
                    保存图片
                  </el-button>
                </div>
              </div>

              <!-- 空状态 -->
              <div v-else class="empty-state">
                <i class="el-icon-picture-outline"></i>
                <p>请选择拍照或上传图片</p>
              </div>
            </el-card>
          </el-col>

          <!-- 右侧：裁剪区域 -->
          <el-col :span="8">
            <el-card class="right-panel">
              <div class="camera-controls" v-if="showCamera">
                <el-button type="danger" @click="capturePhoto">
                  <i class="el-icon-camera"></i>
                  拍摄
                </el-button>
                <el-button @click="closeCamera">
                  <i class="el-icon-close"></i>
                  关闭摄像头
                </el-button>
              </div>
              <div class="cropper-controls" v-if="previewImage">
                <el-button type="primary" @click="cropImage">
                  <i class="el-icon-check"></i>
                  确认裁剪
                </el-button>
                <el-button @click="cancelCrop">
                  <i class="el-icon-close"></i>
                  取消
                </el-button>
              </div>
              <el-alert v-if="!(showCamera || showCropper || croppedImage)"
                  title="摄像头未开启"
                  type="info"
                  :closable="false"
                  show-icon
              >
                <p>请点击"拍照"按钮进行拍照，或点击"上传图片"</p>
              </el-alert>
              <el-alert
                  v-if="showCamera"
                  title="摄像头已开启"
                  type="info"
                  :closable="false"
                  show-icon
              >
                <p>请点击"拍摄"按钮进行拍照，或点击"关闭摄像头"取消</p>
              </el-alert>

              <el-alert
                  v-else-if="showCropper"
                  title="裁剪模式"
                  type="warning"
                  :closable="false"
                  show-icon
              >
                <p>请调整裁剪框位置和大小，然后点击"确认裁剪"</p>
              </el-alert>

              <el-alert
                  v-else-if="croppedImage"
                  title="裁剪完成"
                  type="success"
                  :closable="false"
                  show-icon
              >
                <p>图片裁剪完成，可以下载或复制图片</p>
              </el-alert>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </el-dialog>
</template>

<script>
import {VueCropper} from 'vue-cropper'
import 'vue-cropper/next/dist/index.css'
import http from "@/utils/http";

export default {
  name: 'PhotoCropper',
  components: {
    VueCropper
  },
  data() {
    return {
      visibleFlag:false,
      showCamera: false,
      showCropper: false,
      previewImage: '',
      cropperImage: '',
      croppedImage: '',
      stream: null,
      fileName: 'photo.jpg'
    }
  },
  methods: {
    showModal(url) {
      this.resetAll();
      this.visibleFlag = true;
    },
    hideModal() {
      this.visibleFlag = false;
    },
    // 打开摄像头
    async openCamera() {
      try {
        this.showCamera = true
        this.previewImage = ''
        this.$nextTick(async() => {
          this.stream = await navigator.mediaDevices.getUserMedia({
            video: {
              width: { ideal: 1280 },
              height: { ideal: 720 }
            }
          })
          this.$refs.video.srcObject = this.stream
          this.$message.success('摄像头已开启')
        })
      } catch (error) {
        this.$message.error('无法访问摄像头：' + error.message)
        console.error('摄像头访问失败：', error)
      }
    },

    // 关闭摄像头
    closeCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop())
        this.stream = null
        this.$message.info('摄像头已关闭')
      }
      this.showCamera = false
    },

    // 拍照
    capturePhoto() {
      const video = this.$refs.video
      const canvas = this.$refs.canvas
      const context = canvas.getContext('2d')

      // 设置canvas尺寸与视频相同
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight

      // 在canvas上绘制当前视频帧
      context.drawImage(video, 0, 0, canvas.width, canvas.height)

      // 获取图片数据
      const imageData = canvas.toDataURL('image/jpeg', 0.8)

      // 关闭摄像头
      this.closeCamera()

      // 设置预览图片
      this.previewImage = imageData
      this.$message.success('拍照成功')

      this.startCrop()
    },

    // 上传图片
    uploadImage() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (e) => {
        const file = e.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewImage = e.target.result
            this.fileName = file.name
            this.$message.success('图片上传成功')
            this.startCrop();
          }
          reader.readAsDataURL(file)
        }
      }
      input.click()
    },

    // 开始裁剪
    startCrop() {
      this.cropperImage = this.previewImage
      this.showCropper = true
      this.$message.info('请调整裁剪框位置和大小')
    },

    // 实时裁剪预览
    realTime(data) {
      console.log('实时裁剪数据：', data)
    },

    // 确认裁剪
    cropImage() {
      this.$refs.cropper.getCropData((data) => {
        this.croppedImage = data
        this.showCropper = false
        this.$message.success('图片裁剪完成')
      })
    },

    // 取消裁剪
    cancelCrop() {
      this.showCropper = false
      this.cropperImage = ''
      this.$message.info('已取消裁剪')
    },

    // 下载图片
    downloadImage() {
      const link = document.createElement('a')
      link.download = this.fileName
      link.href = this.croppedImage
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.$message.success('图片下载成功')
    },

    // 复制图片到剪贴板
    async copyImage() {
      try {
        // 将base64转换为blob
        const response = await fetch(this.croppedImage)
        const blob = await response.blob()

        // 复制到剪贴板
        await navigator.clipboard.write([
          new ClipboardItem({
            [blob.type]: blob
          })
        ])

        this.$message.success('图片已复制到剪贴板')
      } catch (error) {
        this.$message.error('复制失败：' + error.message)
      }
    },

    // 重置所有状态
    resetAll() {
      this.closeCamera()
      this.showCropper = false
      this.previewImage = ''
      this.cropperImage = ''
      this.croppedImage = ''
      this.$message.info('已重置所有状态')
    },
    handleUploadImage() {
      this.$nextTick(() => {
        const url = '/server/oss/base64/upload';
        let param = {
          base64: this.croppedImage,
        };
        http.post(url, param).then(response => {
          console.log('response___',response);
          if(response.code == 200){
            this.$emit('save', response?.data?.url)
            this.hideModal()
          }else{
            this.$message.error(response.message || '拍照失败');
          }
        }).catch((err) => {
          this.$message.error("页面停留过长,请重新打开弹窗");
        });
      })
    }
  },
  // 组件销毁时关闭摄像头
  beforeDestroy() {
    this.closeCamera()
  }
}
</script>

<style scoped>
.photo-cropper-container {

  margin: 0 auto;
}
.photo-cropper-container .el-button{
  color: #fff!important;
}
.photo-cropper-container .el-button--default{
  color: #7e84a3!important;
}
.mb-20 {
  margin-bottom: 20px;
}

.mt-20 {
  margin-top: 20px;
}

.left-panel, .right-panel {
  display: flex;
  flex-direction: column;
}

.left-panel .el-card__body, .right-panel .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.camera-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.camera-video {
  width: 100%;
  max-height: 500px;
  border: 2px solid #409EFF;
  border-radius: 8px;
  margin-bottom: 20px;
}

.camera-controls {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.preview-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.preview-image {
  max-width: 100%;
  height: auto;
  border: 2px solid #67C23A;
  border-radius: 8px;
  margin-bottom: 20px;
}

.preview-controls {
  margin-bottom: 20px;
}

.cropper-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 500px;
}

.cropper-container .vue-cropper {
  flex: 1;
  min-height: 300px;
  border: 2px solid #67C23A;
  border-radius: 8px;
}

.cropper-controls {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.result-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.cropped-image-wrapper {
  margin: 20px 0;
  border: 2px solid #67C23A;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.cropped-image {
  width: 400px;
  height: 400px;
  display: block;
}

.result-controls {
  display: flex;
  gap: 15px;
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 15px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .el-col {
    margin-bottom: 20px;
  }

  .left-panel, .right-panel {
    height: auto;
    min-height: 400px;
  }
}

@media (max-width: 768px) {
  .photo-cropper-container {
    padding: 10px;
  }

  .camera-video {
    max-width: 100%;
  }

  .cropped-image {
    max-width: 100%;
  }

  .camera-controls, .cropper-controls, .result-controls {
    flex-direction: column;
    align-items: center;
  }
}
</style>